/**
 * Created by Languagenut on 15/04/2019.
 */

import React  from 'react';
import $ from "jquery"

export default class BackButton extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            toggle:false,
        };
    }

    componentWillUnmount(){

    }

    componentDidMount(){

    }

    onClick(){
        window.history.back()
    }

    render(){
        return <span onClick={this.onClick.bind(this)}>
            <span className="fa fa-arrow-left"></span>

        </span>
    }
}